<template>
	<div>
		<side-bar>
			<template v-slot:header>
       	<v-icon>settings_ethernet</v-icon>
        <v-toolbar-title style="font-size: 16px;">Instances online</v-toolbar-title>
     	</template>

     	<template v-slot:twosubheader v-if="$is_admin()">

				<v-text-field
					:dark="$dark()"
	        flat
	        label="Search"
	        prepend-inner-icon="search"
					solo
					hide-details
					v-model="search_text"
					color="deep-orange"
	      ></v-text-field>

				<v-divider />

        <v-tabs grow v-model="tab" :color="$dark() ? 'gray darken-4' : 'deep-orange'" dark slider-color="yellow">
        		<v-tab key="input" href="#input">Input</v-tab>
        		<v-tab key="output" href="#output">Output</v-tab>
        		<v-tab key="system" href="#system">System</v-tab>
        		<v-tab key="servers" href="#servers">Servers</v-tab>
        </v-tabs>
      </template>

			<v-list dense two-line>
          <template v-for="instance in instances">
						<v-menu offset-x :close-on-content-click="false" v-model="instance_menu[instance.id]" style="width: 100%;">

							<v-list-tile slot="activator" style="width: 100%;" v-model="instance_menu[instance.id]" @click="">
								<v-list-tile-content>
									<v-list-tile-title>{{title(instance)}}</v-list-tile-title>
									<v-list-tile-sub-title class="grey--text text--darken-1">{{channel_title_for_instance(instance)}}</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<template v-if="version_found(instance)">
										<span :class="version_color(instance)">{{version(instance)}}</span>
									</template>
									<template v-if="!version_found(instance) && !is_server(instance)">
										<v-icon color="red" class="text--lighten-2" small>warning</v-icon>
									</template>
								</v-list-tile-action>
							</v-list-tile>

							<Instance v-model="instance_menu[instance.id]" :instance="instance" v-if="instance_menu[instance.id] && $is_admin()" />
						</v-menu>

          </template>
        </v-list>


		</side-bar>

  </div>
</template>

<script>
import InstanceModel from '@/models/instance.js'
import ChannelModel from '@/models/channel.js'
import Instance from '../dashboard/Instance'
import Vue from 'vue'
import SideBar from '@/components/SideBar.vue'
import naturalSort from 'natural-sort'

export default {
	components: {
		Instance,
		SideBar
	},
	data () {
		return {
			tab: "input",
			instance_menu: {},
			search_text: "",
			latest_version: "",
			natural_sort: naturalSort()
		}
	},
	computed: {
    instances () {
			var self = this;
			var type = this.tab;
			var ret = [];
			if(type == "servers") {
				ret = _.concat(
					InstanceModel.instances_by_type("headend", true),
					InstanceModel.instances_by_type("mediamtx", true),
					InstanceModel.instances_by_type("clipper", true)
				);
			} else {
				if (type == "system") {
					ret = _.concat(
						InstanceModel.instances_by_type("input", true),
						InstanceModel.instances_by_type("output", true)
					);
				} else {
					ret = InstanceModel.instances_by_type(type, true);
				}


				ret = _.filter(ret, function(instance) {
					var ch = InstanceModel.channel(instance);
					if (typeof(ch) == "undefined") return true;
					if (type == "system") {
						return ch.meta["system_channel"] === true;
					} else {
						return ch.meta["system_channel"] !== true;
					}

				})
			}

			var search = (this.search_text || "").toLowerCase();
			if (search.length > 0) {
				ret = _.filter(ret, function(instance) {
					ret = false;
					if (self.title(instance).toLowerCase().includes(search)) ret = true;
					if (self.channel_title_for_instance(instance).toLowerCase().includes(search)) ret = true;
					return ret;
				})
			}
			return ret.sort((a,b) => {
				return self.natural_sort(self.title(a), self.title(b));
			});
    }
  },
  mounted () {
  	this.load_latest_version();
  },
  methods: {
  	load_latest_version () {
  		var self = this;
  		var url = "kepitstreamer/3/update/latest"
  		Vue.http.get(url).then((response) => {
        self.latest_version = response.body.latest.version;
      }, (response) => {
      });
  	},

    title (instance) {
      return InstanceModel.title(instance);
    },
    version (instance) {
      return InstanceModel.streamer_version(instance);
    },
    version_color (instance) {
    	if (this.latest_version == "") return "";
     	var v = this.version(instance);
     	if (v.startsWith("v2")) {
	    	if (v != this.latest_version) return "red";
	    }
    	return "";
    },
    version_found (instance) {
    	var v = this.version(instance);
    	if (v == "" || typeof(v) == "undefined" || v == null) return false;
    	return true;
    },
  	channel_title_for_instance (instance) {
      var ch = InstanceModel.channel(instance);
      return ChannelModel.title(ch);
    },
    is_server(instance) {
    	return _.includes(["headend", "mediamtx", "clipper"], instance.type)
    }
  }
}
</script>
